"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
/**
 * A simple class that wraps an event name string
 */
class Event {
    constructor(eventName) {
        this._eventName = eventName;
    }
    get eventName() {
        return this._eventName;
    }
}
exports.Event = Event;
exports.default = Event;
//# sourceMappingURL=Event.js.map